<template>
   <div class="content-wrapper" id='survey-section' v-html='iframe'>
    <!-- <iframe id="frame3d333" frameborder="0" width="100%" scrolling="auto"  
    style="margin-top: -4px;" onload="this.style.height=document.body.clientHeight-84"  
    height="1110px" :src="url"></iframe>    -->
  </div>
</template>

<script>
import config from '@/com/config'

export default {
  name: 'formweb',
  data() {
    return {
      surveyType: '',
      surveyId: '',
      iframe: '',
      url: ''
    }
  },
  methods: {
    resize() {
      document.getElementById('frame3d').style.height =
        document.body.clientHeight - 84 + 'px'
    },
    setPageUrl() {
      switch (this.surveyType) {
        case 'tablelist':
          this.url =
            config.surveywebUrl +
            //'//192.168.11.62:8889/view/web.html#/' +
            `tablelist?formId=${
              this.surveyId
            }&orgType=3&type=0&token=${window.localStorage.getItem(
              'Haiziguo-Token'
            )}`
          break
        case 'datalist':
          this.url =
            config.surveywebUrl +
            // '//192.168.11.62:8889/view/web.html#/' +
            `datalist?formId=${
              this.surveyId
            }&orgType=3&type=0&token=${window.localStorage.getItem(
              'Haiziguo-Token'
            )}`
          break
      }
    }
  },
  mounted() {
    // let div = document.getElementById('survey-section')

    // let iframe = document.createElement('iframe')

    // iframe.src = this.url

    // div.appendChild(iframe)
    this.iframe = `<iframe id="frame3d333" frameborder="0" width="100%" scrolling="auto"  
    style="margin-top: -4px;" 
    height="1110px" src="${this.url}"></iframe>`
  },
  created() {
    this.surveyType = this.$route.params.surveyType
    this.surveyId = this.$route.params.surveyId

    this.setPageUrl()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/survey/index.vue?ac51170a